export default __webpack_public_path__ + "static/media/icon-squad.bcbea59e.webp";